import { Component, HostBinding, Inject } from '@angular/core';

@Component({
  selector: 'navigation-external',
  template: require('./navigation-external.component.html'),
  styles: [require('./navigation-external.component.scss')],
})
export class NavigationExternalComponent {
  @HostBinding('attr.role') role = 'navigation'; 

  constructor(
    @Inject('$state') private $state,
  ){}

  openPatientAgreement() {
    window.open(this.$state.href('patient_agreement'))
  }

  openPrivacyStatement() {
    window.open(this.$state.href('privacy_statement'))
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/navigation-external/navigation-external.component.ts